import { FC } from 'react';

import {
    Card,
    FullPageContainer,
    GridColumn,
    GridLayout,
    GridRow,
    Table,
    useBreakpoint,
    VSpacing,
} from '@hh.ru/magritte-ui';

import { BidsAndBudgetsTableBody } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableBody/BidsAndBudgetsTableBody';
import { BidsAndBudgetsTableHeader } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableHeader/BidsAndBudgetsTableHeader';

export const BidsAndBudgetsTable: FC = () => {
    const { isMobile } = useBreakpoint();

    return (
        <GridLayout>
            <GridRow>
                <GridColumn xs={4} s={8} m={12}>
                    <FullPageContainer>
                        {({ paddingLeft, paddingRight }) => {
                            return (
                                <Card stretched>
                                    {!isMobile ? (
                                        <Table
                                            stickyHeader
                                            divider
                                            dividerTop={false}
                                            paddingLeft={paddingLeft}
                                            paddingRight={paddingRight}
                                            cellsGap={48}
                                        >
                                            <BidsAndBudgetsTableHeader
                                                paddingLeft={paddingLeft}
                                                paddingRight={paddingRight}
                                            />
                                            <BidsAndBudgetsTableBody
                                                paddingLeft={paddingLeft}
                                                paddingRight={paddingRight}
                                            />
                                        </Table>
                                    ) : (
                                        <>
                                            <VSpacing default={8} />
                                            <BidsAndBudgetsTableHeader
                                                paddingLeft={paddingLeft}
                                                paddingRight={paddingRight}
                                            />
                                            <VSpacing default={24} />
                                            <BidsAndBudgetsTableBody
                                                paddingLeft={paddingLeft}
                                                paddingRight={paddingRight}
                                            />
                                        </>
                                    )}
                                </Card>
                            );
                        }}
                    </FullPageContainer>
                </GridColumn>
            </GridRow>
        </GridLayout>
    );
};
